/**
 * Arabic for resource allocation (stands, gates, check-in counters, reclaim
 * belts). Proposed; pending native aviation review. Resource codes, flight
 * designators and ICAO size letters are kept as the industry writes them.
 */
const ar: Record<string, string> = {
  "Resource allocation": "تخصيص الموارد",
  "Stands, gates, check-in counters and reclaim belts as one plan, built on the flight record's predicted times and how sure they are: every back-to-back pair carries its chance of meeting; a delay, a closure or a bigger aircraft is re-planned with the fewest moves, one other flight moved or a long stay towed before anybody is sent to a bus, and the gate follows its stand; what the automation level allows is applied on its own, the rest proposed with the reason a person is needed; every placement explained; what people overrule is learned; and a what-if and the cheapest maintenance window are one question away.":
    "المواقف والبوابات وكاونترات إنهاء الإجراءات وسيور استلام الأمتعة كخطة واحدة، مبنية على الأوقات المتوقعة في سجل الرحلات ومدى الثقة بها: لكل رحلتين متتاليتين احتمال تلاقٍ محسوب؛ والتأخير أو الإغلاق أو الطائرة الأكبر يُعاد تخطيطه بأقل عدد من التغييرات — بنقل رحلة أخرى أو سحب طائرة طويلة المكوث قبل إرسال أي أحد إلى الحافلة — والبوابة تتبع موقفها؛ ما يسمح به مستوى الأتمتة يُطبَّق تلقائياً والباقي يُقترح مع سبب الحاجة إلى شخص؛ وكل تخصيص مشروح؛ وما يغيّره الناس يُتعلَّم منه؛ وسؤال «ماذا لو» وأنسب نافذة للصيانة على بُعد سؤال واحد.",
  "Stands, gates, check-in counters and reclaim belts as one plan — built on the flight record's predicted times and how sure they are, re-planned with the fewest moves when a delay or a closure breaks it, and every placement explained.":
    "المواقف والبوابات وكاونترات إنهاء الإجراءات وسيور الأمتعة كخطة واحدة — مبنية على الأوقات المتوقعة في سجل الرحلات ومدى الثقة بها، يُعاد تخطيطها بأقل عدد من التغييرات عندما يكسرها تأخير أو إغلاق، وكل تخصيص مشروح.",

  "No flights on the record in the next hours, so there is nothing to plan. The flight record fills from the airlines' seasonal schedule (SSIM) and their movement messages — load the schedule on Flight record.":
    "لا رحلات في السجل خلال الساعات القادمة، فلا شيء للتخطيط. يمتلئ سجل الرحلات من الجدول الموسمي لشركات الطيران (SSIM) ورسائل الحركة — حمّل الجدول من صفحة سجل الرحلات.",

  /* kinds */
  "Check-in counters": "كاونترات إنهاء الإجراءات",
  "Reclaim belts": "سيور استلام الأمتعة",
  Counters: "الكاونترات",
  Belts: "السيور",
  stand: "موقف",
  gate: "بوابة",
  counters: "كاونترات",
  belt: "سير",

  /* summary and tiles */
  "Plan health {h} of 100: {c} conflicts, {u} without a place.": "سلامة الخطة {h} من 100: {c} تعارضات، و{u} بلا تخصيص.",
  "A re-plan is waiting: {n} changes.": "إعادة تخطيط بانتظار القرار: {n} تغييرات.",
  "No re-plan is waiting.": "لا توجد إعادة تخطيط بانتظار القرار.",
  "{p}% of passenger stands on a bridge; {n} people by bus.": "{p}% من مواقف الركاب على جسر؛ و{n} شخصاً بالحافلة.",
  "What is wrong with the plan?": "ما الخلل في الخطة؟",
  "plan health": "سلامة الخطة",
  "of 100 — conflicts, risk, buses and tows": "من 100 — التعارضات والمخاطر والحافلات والسحب",
  conflicts: "تعارضات",
  "expected clashes": "التلاقيات المتوقعة",
  "from the predictions' uncertainty": "من عدم اليقين في التوقعات",
  "on a bridge": "على جسر",
  "{n} people by bus": "{n} شخصاً بالحافلة",
  "waiting for you": "بانتظارك",
  "changes in a proposed re-plan": "تغييرات في إعادة تخطيط مقترحة",
  "nothing to decide": "لا شيء للقرار",
  "{n} without a place|{n} without a place": "لا أحد بلا تخصيص|{n} بلا تخصيص|{n} بلا تخصيص|{n} بلا تخصيص|{n} بلا تخصيص|{n} بلا تخصيص",

  /* plan tab */
  "Automation and rules": "الأتمتة والقواعد",
  "found before anything is moved": "يُكتشف قبل نقل أي شيء",
  "an hour back to ten ahead · the colour is the chance of meeting the next occupant":
    "من ساعة مضت إلى عشر ساعات قادمة · اللون هو احتمال التلاقي مع الشاغل التالي",
  Resource: "المورد",
  "Re-plan now": "أعد التخطيط الآن",
  "Optimize the whole day": "حسّن اليوم كله",
  clear: "خالٍ",
  "some chance of meeting": "احتمال تلاقٍ",
  "likely to meet": "تلاقٍ مرجّح",
  "done or fixed": "منجز أو مثبّت",
  "placed by a person": "خصّصه شخص",
  towed: "مسحوبة",
  "No {kind} are in the register yet.": "لا توجد {kind} في السجل بعد.",
  "Proposed re-plan": "إعادة التخطيط المقترحة",
  "{why} · proposed {at}": "{why} · اقتُرحت {at}",
  "the plan no longer holds": "الخطة لم تعد صالحة",
  automatic: "تلقائي",
  "optimise the whole day": "تحسين اليوم كله",
  "asked for a re-plan": "طُلبت إعادة التخطيط",
  "show it on the chart": "اعرضها على المخطط",
  "Why it waits for a person:": "لماذا تنتظر شخصاً:",
  "note (optional)": "ملاحظة (اختياري)",
  "Apply the re-plan": "طبّق إعادة التخطيط",
  "without a place": "بلا تخصيص",
  "people by bus": "أشخاص بالحافلة",
  "Nothing would change.": "لن يتغير شيء.",
  "From → to": "من ← إلى",
  tow: "سحب",

  /* why here */
  "Why {what} is where it is": "لماذا {what} في مكانها",
  "Placed on": "مخصّصة على",
  "by a person": "بواسطة شخص",
  "What it costs, and why": "ما تكلّفه، ولماذا",
  "Nothing counts against it.": "لا شيء يُحسب ضدها.",
  "{pct}% chance of meeting {who}, from how sure both times are.": "احتمال {pct}% للتلاقي مع {who}، من مدى الثقة بالوقتين.",
  "What it passed over": "ما تجاوزه",
  "Nowhere else it could go.": "لا مكان آخر ممكن.",
  "Could not go on": "لا يمكن وضعها على",
  "too small": "أصغر من اللازم",
  taken: "مشغول",
  "blocked by a neighbour": "محجوب بموقف مجاور",
  "not reachable from its stand": "لا يُوصل إليه من موقفها",
  "not for this kind of flight": "ليس لهذا النوع من الرحلات",
  "ruled out by a rule": "مستبعد بقاعدة",
  "not in the register": "غير موجود في السجل",
  "Put it somewhere else": "ضعها في مكان آخر",
  "choose…": "اختر…",
  "why (optional)": "السبب (اختياري)",
  "Place it": "خصّصها",
  "The engine remembers where people put each airline, and prefers it next time.":
    "يتذكر المحرك أين يضع الناس كل شركة طيران، ويفضّله في المرة القادمة.",
  "Refused:": "مرفوض:",
  "Place it anyway": "خصّصها على أي حال",
  "Placed. The plan and its checks are updated.": "خُصّصت. حُدِّثت الخطة وفحوصها.",
  "code {s}": "الرمز {s}",
  "{n} person|{n} people": "لا أحد|شخص واحد|شخصان|{n} أشخاص|{n} شخصاً|{n} شخص",
  "{n} desk|{n} desks": "لا كاونتر|كاونتر واحد|كاونتران|{n} كاونترات|{n} كاونتراً|{n} كاونتر",
  estimated: "مقدّر",
  predicted: "متوقع",

  /* what if */
  "What would it do if…": "ماذا سيفعل لو…",
  "the re-plan a closure or a delay would force — nothing is saved": "إعادة التخطيط التي يفرضها إغلاق أو تأخير — لا يُحفظ شيء",
  "A resource closes": "إغلاق مورد",
  "A flight runs late": "تأخر رحلة",
  "Starting in (hours)": "يبدأ بعد (ساعات)",
  "For (hours)": "لمدة (ساعات)",
  "Show me": "أرني",
  "The best time for maintenance": "أنسب وقت للصيانة",
  "every half-hour start over the next day, re-planned around the closure and costed":
    "كل بداية نصف ساعة خلال اليوم القادم، يُعاد التخطيط حول الإغلاق وتُحسب كلفته",
  "Hours of work": "ساعات العمل",
  "With the change and nothing moved → after the engine re-plans around it:": "مع التغيير ودون نقل شيء ← بعد أن يعيد المحرك التخطيط حوله:",
  "Find the windows": "ابحث عن النوافذ",

  /* automation */
  "How much it does on its own": "ما يفعله من تلقاء نفسه",
  "per resource: planned by hand, advice only, or applied automatically within its limits":
    "لكل مورد: تخطيط يدوي، أو نصح فقط، أو تطبيق تلقائي ضمن حدوده",
  "By hand": "يدوي",
  Advise: "نصح",
  Automatic: "تلقائي",
  "Buffer (min)": "الفاصل (دقيقة)",
  "Freeze (min)": "التجميد (دقيقة)",
  "Risk limit (%)": "حد المخاطرة (%)",
  "Most changes alone": "أقصى تغييرات تلقائية",
  "Even when automatic, it never tows, never changes a gate after passengers were told, never sends people to a bus instead of a bridge, and never leaves the plan worse — those always wait for a person.":
    "حتى في الوضع التلقائي، لا يسحب طائرة، ولا يغيّر بوابة بعد إبلاغ الركاب، ولا يرسل الناس إلى حافلة بدل جسر، ولا يترك الخطة أسوأ — هذه تنتظر شخصاً دائماً.",
  "{n} re-plans proposed": "{n} إعادات تخطيط مقترحة",
  "{n} applied by a person": "{n} طبّقها شخص",
  "{n} rejected": "{n} مرفوضة",
  "{n} applied automatically": "{n} طُبّقت تلقائياً",
  "Controllers accepted {pct}% of the last {n} proposals as they were — these could be applied automatically.":
    "قبل المراقبون {pct}% من آخر {n} مقترحات كما هي — يمكن تطبيقها تلقائياً.",
  "What it has learned": "ما تعلّمه",
  "from people placing flights over its choice — counted, never hidden": "من تخصيص الناس للرحلات خلافاً لاختياره — معدود، لا يُخفى",
  "Nothing yet.": "لا شيء بعد.",
  "{n} time|{n} times": "ولا مرة|مرة واحدة|مرتان|{n} مرات|{n} مرة|{n} مرة",
  "Every change": "كل تغيير",
  "who or what moved which flight, and why": "من أو ما الذي نقل أي رحلة، ولماذا",
  "the engine, automatically": "المحرك، تلقائياً",
  "No changes yet today.": "لا تغييرات اليوم بعد.",
  engine: "المحرك",
  person: "شخص",
  "what the airport requires, prefers, avoids or forbids — a rule is kept to, and named when it decides":
    "ما يشترطه المطار أو يفضّله أو يتجنبه أو يمنعه — تُلتزم القاعدة، وتُسمّى حين تحسم",
  Effect: "الأثر",
  code: "الرمز",
  prefer: "تفضيل",
  require: "اشتراط",
  forbid: "منع",
  "Airline (optional)": "شركة الطيران (اختياري)",
  "Codes (comma; @A for a group)": "الرموز (بفواصل؛ ‎@A لمجموعة)",
  "Add the rule": "أضف القاعدة",

  /* the engine's reasons */
  "{code} is not in the register.": "{code} غير موجود في السجل.",
  "{code} is closed ({ref}): {why}": "{code} مغلق ({ref}): {why}",
  "{code} is closed: {why}": "{code} مغلق: {why}",
  "{code} takes code {max}; {what} is code {size}.": "{code} يستوعب الرمز {max}؛ و{what} من الرمز {size}.",
  "{code} is not for {use} flights.": "{code} ليس لرحلات {use}.",
  "{what} is on {stand}, which is reached through gate {gate}.": "{what} على {stand}، ويُوصل إليه عبر البوابة {gate}.",
  "{what} is on remote stand {stand}; it needs a bus gate.": "{what} على الموقف البعيد {stand}؛ ويحتاج بوابة حافلات.",
  "{what} has no stand yet; only a bus gate can serve it.": "{what} بلا موقف بعد؛ لا تخدمه إلا بوابة حافلات.",
  "Rule: {note}": "قاعدة: {note}",
  "{code} is taken by {who} from {from} to {to}.": "{code} يشغله {who} من {from} إلى {to}.",
  "{code} cannot be used while {other} is occupied by {who}.": "لا يمكن استخدام {code} بينما يشغل {who} الموقف {other}.",
  "remote: {n} people by bus": "بعيد: {n} شخصاً بالحافلة",
  "a cargo flight away from the cargo stands": "رحلة شحن بعيداً عن مواقف الشحن",
  "a widebody's bags on a short belt: slower reclaim": "أمتعة طائرة عريضة على سير قصير: استلام أبطأ",
  "uses a belt kept for widebodies": "يستخدم سيراً مخصصاً للطائرات العريضة",
  "desk order": "ترتيب الكاونترات",
  "{n} desk fewer than the load needs: longer queues|{n} desks fewer than the load needs: longer queues":
    "لا نقص|كاونتر واحد أقل مما يحتاجه الحِمل: طوابير أطول|كاونتران أقل مما يحتاجه الحِمل: طوابير أطول|{n} كاونترات أقل مما يحتاجه الحِمل: طوابير أطول|{n} كاونتراً أقل مما يحتاجه الحِمل: طوابير أطول|{n} كاونتر أقل مما يحتاجه الحِمل: طوابير أطول",
  "{pct}% chance of meeting {who}": "احتمال {pct}% للتلاقي مع {who}",
  "preferred: {note}": "مفضّل: {note}",
  "avoided: {note}": "متجنَّب: {note}",
  "a change within 90 minutes of the flight": "تغيير خلال 90 دقيقة من الرحلة",
  "a change to the plan": "تغيير في الخطة",
  "a gate change after passengers were told": "تغيير بوابة بعد إبلاغ الركاب",
  "two tows": "عمليتا سحب",
  "not {what}": "ليس {what}",
  "no better on any count": "ليس أفضل في أي جانب",
  "{what} has no {kind}.": "{what} بلا {kind}.",
  "{a} and {b} are both on {code} at {at}.": "{a} و{b} كلاهما على {code} في {at}.",
  "{list} and {last} are all on {code} at {at}.": "{list} و{last} جميعها على {code} في {at}.",
  "{pct}% chance {a} and {b} meet on {code}.": "احتمال {pct}% أن يتلاقى {a} و{b} على {code}.",
  "follows its stand, now {code}": "تتبع موقفها، الآن {code}",
  "its flight has no stand; a bus gate until it has one": "رحلتها بلا موقف؛ بوابة حافلات إلى أن يكون لها موقف",
  "gate change {n} min before departure": "تغيير البوابة قبل الإقلاع بـ{n} دقيقة",
  "{n} people by bus instead of a bridge": "{n} شخصاً بالحافلة بدل الجسر",
  "makes room for another flight": "يفسح المجال لرحلة أخرى",
  "had none": "لم يكن لها تخصيص",
  "could not be kept": "تعذّر الإبقاء عليها",
  "No {kind} for {what}: {why}": "لا {kind} لـ{what}: {why}",
  "Nothing to change.": "لا شيء للتغيير.",
  "{kind} are planned by hand.": "{kind} تُخطَّط يدوياً.",
  "{kind} are set to advise only.": "{kind} مضبوطة على النصح فقط.",
  "{n} changes to {kind}; at most {max} are made without a person.": "{n} تغييرات على {kind}؛ لا يُجرى دون شخص أكثر من {max}.",
  "It needs a tow, and a tow is always a person's call.": "تحتاج سحباً، والسحب قرار شخص دائماً.",
  "It changes a gate after passengers were told.": "تغيّر بوابة بعد إبلاغ الركاب.",
  "It sends people to a bus instead of a bridge.": "ترسل الناس إلى حافلة بدل جسر.",
  "It would leave the plan worse than it is.": "ستترك الخطة أسوأ مما هي.",
  "what-if closure": "إغلاق افتراضي",
  maintenance: "صيانة",
  "{moves} · {bus}": "{moves} · {bus}",
  "{n} more people bussed": "{n} شخصاً إضافياً بالحافلة",
  "nobody bussed": "لا أحد بالحافلة",
  "nothing moves": "لا شيء يتحرك",
  "That flight is not on today's plan.": "هذه الرحلة ليست في خطة اليوم.",
  "keeps a stand {n} size larger busy|keeps a stand {n} sizes larger busy":
    "يشغل موقفاً بنفس الحجم|يشغل موقفاً أكبر بدرجة|يشغل موقفاً أكبر بدرجتين|يشغل موقفاً أكبر بـ{n} درجات|يشغل موقفاً أكبر بـ{n} درجة|يشغل موقفاً أكبر بـ{n} درجة",
  "learned: controllers put {op} here {times}": "متعلَّم: وضع المراقبون {op} هنا {times}",
  "{n} too small|{n} too small": "لا شيء أصغر|واحد أصغر من اللازم|اثنان أصغر من اللازم|{n} أصغر من اللازم|{n} أصغر من اللازم|{n} أصغر من اللازم",
  "{n} taken|{n} taken": "لا مشغول|واحد مشغول|اثنان مشغولان|{n} مشغولة|{n} مشغولاً|{n} مشغول",
  "{n} blocked by a neighbour|{n} blocked by a neighbour":
    "لا محجوب|واحد محجوب بمجاور|اثنان محجوبان بمجاور|{n} محجوبة بمجاور|{n} محجوباً بمجاور|{n} محجوب بمجاور",
  "{n} closed|{n} closed": "لا مغلق|واحد مغلق|اثنان مغلقان|{n} مغلقة|{n} مغلقاً|{n} مغلق",
  "{n} not reachable from its stand|{n} not reachable from its stand":
    "لا شيء|واحد لا يُوصل إليه من موقفها|اثنان لا يُوصل إليهما من موقفها|{n} لا يُوصل إليها من موقفها|{n} لا يُوصل إليها من موقفها|{n} لا يُوصل إليها من موقفها",
  "{n} not for this kind of flight|{n} not for this kind of flight":
    "لا شيء|واحد ليس لهذا النوع من الرحلات|اثنان ليسا لهذا النوع|{n} ليست لهذا النوع|{n} ليست لهذا النوع|{n} ليست لهذا النوع",
  "{n} ruled out by a rule|{n} ruled out by a rule":
    "لا شيء|واحد مستبعد بقاعدة|اثنان مستبعدان بقاعدة|{n} مستبعدة بقاعدة|{n} مستبعداً بقاعدة|{n} مستبعد بقاعدة",
  "{n} flight left without a place|{n} flights left without a place":
    "لا رحلة بلا تخصيص|رحلة واحدة بلا تخصيص|رحلتان بلا تخصيص|{n} رحلات بلا تخصيص|{n} رحلة بلا تخصيص|{n} رحلة بلا تخصيص",
  "{n} change|{n} changes": "لا تغيير|تغيير واحد|تغييران|{n} تغييرات|{n} تغييراً|{n} تغيير",
};
export default ar;
